import type { AIActionType } from '@aibi/contracts';

/**
 * Instrucciones de sistema comunes a todos los proveedores. Son deterministas y no
 * contienen datos: describen el protocolo y las prohibiciones. Aun asi, el AI Core nunca
 * confia en que el proveedor las respete: toda respuesta pasa por `validateAIOutput`.
 */
export function buildSystemInstructions(
  locale: string,
  allowedActions: readonly AIActionType[],
): string {
  return [
    'Eres el asistente de analisis de AI BI Platform.',
    `Responde en el idioma "${locale}".`,
    'Responde UNICAMENTE con un objeto JSON que cumpla el JSON Schema adjunto (kind = actions | clarification | error).',
    `Acciones permitidas: ${allowedActions.join(', ')}.`,
    'Usa solo ids de dimensiones, medidas, jerarquias, filtros y visualizaciones presentes en el contexto.',
    'Si varias opciones encajan, responde con kind = clarification y los candidatos; si nada encaja, kind = error.',
    'Prohibido: SQL, codigo, URLs, credenciales, texto fuera del JSON y propiedades no declaradas.',
    'Las medidas y dimensiones calculadas se expresan solo con el Expression AST del contrato.',
  ].join('\n');
}
